import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GINJA_API_BASE,
  SSO_COOKIE_SENTINEL,
} from "../Utils/api/ginjaAuth";

/** Bearer for local/off-cookie flows; omit when SSO uses HttpOnly cookie sentinel. */
const brandRequestHeaders = () => {
  const token =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("auth-token")
      : null;
  if (!token || token === SSO_COOKIE_SENTINEL) return {};
  return { Authorization: `Bearer ${token}` };
};

const DEFAULT_COLORS = {
  primary: "#005B60",
  secondary: "#FF601B",
  accent: "#D1133E",
};

const initialState = {
  brandName: "",
  brandTagline: "",
  logoUrl: "",
  faviconUrl: "",
  colors: DEFAULT_COLORS,
  defaultTimezone: "",
  defaultCurrency: "",
  defaultLanguage: "",
  loading: false,
  loaded: false,
  error: null,
};

export const fetchBrandSettings = createAsyncThunk(
  "brand/fetchBrandSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${GINJA_API_BASE}/brand-settings`, {
        headers: brandRequestHeaders(),
        withCredentials: true,
      });
      return response.data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchBrandSettings.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchBrandSettings.fulfilled, (state, action) => {
      state.loading = false;
      state.loaded = true;
      const data = action.payload || {};
      state.brandName = data.brand_name || "";
      state.brandTagline = data.brand_tagline || "";
      state.logoUrl = data.logo_url || "";
      state.faviconUrl = data.favicon_url || "";
      state.colors = {
        primary: data.colors?.primary || DEFAULT_COLORS.primary,
        secondary: data.colors?.secondary || DEFAULT_COLORS.secondary,
        accent: data.colors?.accent || DEFAULT_COLORS.accent,
      };
      state.defaultTimezone = data.default_timezone || "";
      state.defaultCurrency = data.default_currency || "";
      state.defaultLanguage = data.default_language || "";
    });
    builder.addCase(fetchBrandSettings.rejected, (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.error = action.payload || action.error?.message;
    });
  },
});

export default brandSlice.reducer;
